/* eslint-disable max-len */
export const categoryItemImagesMockData = {
  laptop:
    'https://firebasestorage.googleapis.com/v0/b/popsygae.appspot.com/o/laptop-images%2FMacBook%20A2179%2FMacBook-A2179-1.jpg?alt=media&token=d23c1c83-da0c-4e23-8973-862f4f26b6ff',
  phone:
    'https://firebasestorage.googleapis.com/v0/b/popsygae.appspot.com/o/Smartphone%20Images%2FiPhone%2013%20Pro%20Max%2FGraphite%2FBlack.jpg?alt=media&token=19a9ddd3-4248-490b-ab1e-077f82a64623',
  tablet:
    'https://firebasestorage.googleapis.com/v0/b/popsygae.appspot.com/o/Smartphone%20Images%2FiPad%20Pro%203rd%20Gen%2FSilver%2FiPad-Pro-3rd-Gen-Silver-1.jpg?alt=media&token=b52530ac-89f2-4eff-966e-84c6e0c98f45',
  audio:
    'https://firebasestorage.googleapis.com/v0/b/popsygae.appspot.com/o/Accessories%2FAirPods%203rd%20Gen%20(2021)%2F1.jpg?alt=media&token=bd2d1eb9-284d-4732-be45-436972f45672',
  accessory:
    'https://firebasestorage.googleapis.com/v0/b/popsygae.appspot.com/o/Charger%2FMAGSAFE%20Charger%2F1.jpg?alt=media&token=6f8addcc-752a-4cf8-a366-f6cf1afc074d',
  watch:
    'https://firebasestorage.googleapis.com/v0/b/popsygae.appspot.com/o/watch%2Fapple%2Fwatch-series-se-2023-gps-cellular-40mm%2Fsilver-aluminum%2F2.jpg?alt=media&token=1e020c92-8441-4c6b-adad-f896c5d710d0',
  gaming:
    'https://firebasestorage.googleapis.com/v0/b/popsygae.appspot.com/o/playstation%2FPlayStation-4-Pro%2Fblack%2F1.jpg?alt=media&token=22b5dea9-f4f9-4eed-b8c0-98ae6bc0ac65',
};
